import { render, staticRenderFns } from "./ArticleSource.vue?vue&type=template&id=3ac7fdcc"
import script from "./ArticleSource.vue?vue&type=script&lang=ts"
export * from "./ArticleSource.vue?vue&type=script&lang=ts"
import style0 from "./ArticleSource.vue?vue&type=style&index=0&id=3ac7fdcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports